import React from "react";
import { Tabs, Table } from "antd";
import { facultyProfileConfig } from "../../config/facultyProfileConfig";
import "../../styles/components/facultyProfile/teachingLoadTabs.scss";

export default function TeachingLoadTabs({
  activeTab,
  onTabChange,
  selectedTerms,
  onEdit,
  teachingLoadUpouData,
  teachingLoadOtherUpData,
  teachingLoadOutsideUpData,
}) {
  const tabs = facultyProfileConfig.teachingLoad.tabs;

  const dataMap = {
    upou: teachingLoadUpouData,
    otherUp: teachingLoadOtherUpData,
    outsideUp: teachingLoadOutsideUpData,
  };

  const filteredData = (data) =>
    selectedTerms.length === 0
      ? data
      : data.filter((item) => selectedTerms.includes(item.academic_term));

  const items = Object.entries(tabs).map(([key, tab]) => ({
    key,
    label: tab.label,
    children: (
      <Table
        columns={tab.columns}
        dataSource={filteredData(dataMap[key])}
        scroll={{ x: "max-content" }}
        pagination={{ pageSize: 4 }}
        onRow={(record) => ({
          onClick: () => {
            if (onEdit) onEdit(record);
          },
          style: { cursor: "pointer" },
        })}
        rowKey={(record) => record.id}
      />
    ),
  }));

  return (
    <Tabs
      className="teaching-load-tabs"
      activeKey={activeTab}
      items={items}
      onChange={onTabChange}
    />
  );
}
